export class Coordinate {}
